// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"845fc74f63e010f18d73","293":"f4dacca3be367efbdfa1","518":"7628d06a60c4e5691620","779":"d76bd287b1b19976eb06"}[chunkId] + ".js";
};